const SITE_ID = 1;const SITE_UID='9ea10183-1117-4556-9fcb-c94647baee05';const SUBDOMAIN='busan';export { SITE_ID, SITE_UID, SUBDOMAIN }